import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AccountService } from '@app/core/auth/account.service';
import { PrivilegeService } from '@app/core/auth/privilege.service';
import { AppState } from '@app/store/states/app.state';
import { Account } from '@shared/models/account.model';
import { concatMap, map, tap } from 'rxjs/operators';

export const principalResolve: ResolveFn<Account> = () => {
  const appState = inject(AppState);
  const accountService = inject(AccountService);
  const privilegeService = inject(PrivilegeService);
  return accountService.getAccount().pipe(
    tap((user) => (appState.principal = <Account>user)),
    concatMap(() => privilegeService.getLocalPrivileges()),
    tap((privileges) => (appState.privileges = privileges)),
    map(() => appState.principal)
  );
};
